import axios from 'axios';
import { useQuery } from 'react-query';

type Space = {
  name: string;
  spaceCode?: string;
};

const spaceKeys = {
  space: (spaceCode?: string) => ['space', spaceCode],
};

export const useSpace = (spaceCode: string) =>
  useQuery<Space, Error>(
    spaceKeys.space(spaceCode),
    async () => {
      const {
        data: { name },
      } = await axios.get('signup/verify/code', {
        params: {
          spaceCode,
        },
      });
      return {
        name,
        spaceCode,
      };
    },
    {
      enabled: !!spaceCode,
    }
  );
